<template>
  <div :id="overlayId" :class="['modal-overlay', overlayClass]">
    <div :class="[modalContentDefaultClass, modalContentClass]">
      <div v-if="closeButtonVisible" class="close-btn" id="closeModalBtn">
        <img src="/static/images/x.svg"/>
      </div>

      <div class="modal-card">
        <slot name="default"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    closeButtonVisible: {
      type: Boolean,
      default: true
    },
    overlayId: {
      type: String,
      default: ''
    },
    overlayClass: {
      type: [String, Array, Object],
      default: ''
    },
    modalContentDefaultClass: {
      type: String,
      default: 'modal-content'
    },
    modalContentClass: {
      type: [String, Array, Object],
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/modal/BaseModal.vue